import request from '@/utils/request'

//经销商资料
export function miMemberInfo(query) {
    return request({
        url: 'common/miMemberInfo',
        method: 'get',
        params: query
    })
}

//代办处资料
export function miAgentInfo(query) {
    return request({
        url: 'common/miAgentInfo',
        method: 'get',
        params: query
    })
}

// 验证安置人市场个数
export function miMemberRightNum(query) {
    return request({
        url: 'common/miMemberRightNum',
        method: 'get',
        params: query
    })
}

// 获取制度
export function getCompanyBonusType(query) {
    return request({
        url: 'common/getCompanyBonusType',
        method: 'get',
        params: query
    })
}

//账户合计
export function balanceSum(query) {
    return request({
        url: 'account/balanceSum',
        method: 'get',
        params: query
    })
}

// 一级地区列表(国家)
export function getLevel1AlRegions(query) {
    return request({
        url: 'common/getLevel1AlRegions',
        method: 'get',
        params: query
    })
}

//根据地区编码获取其下属地区
export function getAlRegionsByCode(query) {
    return request({
        url: 'common/getAlRegionsByCode',
        method: 'get',
        params: query
    })
}

//根据地区ID获取其下属地区
export function getAlRegionsByID(query) {
    return request({
        url: 'common/getAlRegionsByID',
        method: 'get',
        params: query
    })
}

//根据地区ID获取其下属地区
export function getRecAddrs(query) {
    return request({
        url: 'common/getRecAddrs',
        method: 'get',
        params: query
    })
}

//经销商自助注册获取经销商编号
export function registerGetMemberNo(query) {
    return request({
        url: '/register/getMemberNo',
        method: 'get',
        params: query
    })
}

//经销商自助注册获取经销商编号
export function registerCheckLinkNo(query) {
    return request({
        url: '/register/checkLinkNo',
        method: 'get',
        params: query
    })
}

// 获取6位时间
export function getMemberNoDateFormat() {
    return request({
        url: '/register/getMemberNoDateFormat',
        method: 'get'
    })
}

// 南非 F624-A 促销  2023.9.12 - 2023.10.3
export function AFNAugustPromotion() {
    return request({
        url: 'common/AFNAugustPromotion',
        method: 'get'
    })
}

// 促销时间 经销商/代办处 (CI 2024年8月7日至2024年10月1日)
export function commonCxTime() {
    return request({
        url: 'common/cxTime',
        method: 'get'
    })
}
//
export function procQualificationListByAgent(query) {
    return request({
        url: 'procQualification/listByAgent',
        method: 'get',
        params: query
    })
}
//
export function procQualificationCanUse(query) {
    return request({
        url: 'procQualification/procQualificationCanUse',
        method: 'get',
        params: query
    })
}

//
export function procQualificationSaveOrder(data) {
    return request({
        url: 'procQualification/procQualificationSaveOrder',
        method: 'post',
        data
    })
}

// 资格码报单2查询经销商列表
export function procQualificationListByAgent2(query) {
    return request({
        url: 'procQualification/listByAgentMarchLast',
        method: 'get',
        params: query
    })
}
// 资格码报单2查询资格吗验证
export function procQualificationCanUse2(query) {
    return request({
        url: 'procQualification/procQualificationCanUseMarchLast',
        method: 'get',
        params: query
    })
}

// 
export function getConfig(query) {
    return request({
        url: 'getConfig',
        method: 'get',
        params: query
    })
}